"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorWatcher = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var sentrySdk_1 = require("../../sdks/sentry/sentrySdk");
var firebaseFailureCodes_1 = require("../../constants/firebaseFailureCodes");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var SentrySeverity_1 = require("../../sdks/sentry/SentrySeverity");
var description = 'ErrorWatcher';
var ErrorWatcher = function (_a) {
    var handlePermissionDenied = _a.handlePermissionDenied;
    var dispatch = (0, react_redux_1.useDispatch)();
    var error = (0, react_redux_1.useSelector)(function (state) {
        return state.currentError;
    });
    (0, react_1.useEffect)(function () {
        var _a;
        if (error) {
            var code = error.code, message = error.message, type = error.type, silent = error.silent, errorOrigin = error.description;
            (0, sentrySdk_1.sentrySdk)().captureMessage("errorOrigin: ".concat(errorOrigin, " type: ").concat(type, " code: ").concat(code, " message: ").concat(message), SentrySeverity_1.SentrySeverity.Critical);
            (0, analyticsEventBase_1.analyticsEventBase)({
                event: "Error type: ".concat(type),
                eventParams: {
                    message: message,
                    code: code,
                },
            });
            if (type === 'firebase') {
                if (code === firebaseFailureCodes_1.firebaseFailureCodes.unavailable) {
                    (_a = window.location) === null || _a === void 0 ? void 0 : _a.reload();
                }
                if (code === firebaseFailureCodes_1.firebaseFailureCodes.emailAlreadyInUse) {
                    dispatch({
                        type: 'SET_ALERT_MESSAGE',
                        description: description,
                        values: {
                            location: 'form',
                            actionType: type,
                            type: 'error',
                            message: 'Can not create account because email is already in use.',
                            description: description,
                        },
                    });
                }
                else {
                    if (code === firebaseFailureCodes_1.firebaseFailureCodes.permissionDenied) {
                        handlePermissionDenied === null || handlePermissionDenied === void 0 ? void 0 : handlePermissionDenied();
                    }
                    dispatch({
                        type: 'SET_ALERT_MESSAGE',
                        description: description,
                        values: {
                            location: 'modal',
                            actionType: type,
                            type: 'error',
                            message: message,
                            description: description,
                        },
                    });
                }
            }
            else if (!silent) {
                dispatch({
                    type: 'SET_ALERT_MESSAGE',
                    description: description,
                    values: {
                        location: 'modal',
                        actionType: type,
                        type: 'error',
                        message: message,
                        description: code,
                    },
                });
            }
        }
    }, [error, handlePermissionDenied, dispatch]);
    return null;
};
exports.ErrorWatcher = ErrorWatcher;
